import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
  secondaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      color: theme.oysterTheme.charcoal,
      padding: theme.spacing(1),
      '& > ol': {
        padding: 0,
        listStyle: 'none',
        counterReset: 'item',

        [theme.breakpoints.up('md')]: {
          marginBottom: theme.spacing(1),
        },
      },
      '& > ol > li': {
        position: 'relative',
        paddingLeft: theme.spacing(3),
        counterIncrement: 'item',
        marginBottom: theme.spacing(2),
        fontSize: 14,

        '&:before': {
          content: 'counter(item)',
          color: theme.oysterTheme.charcoal,
          fontSize: 16,
          fontWeight: 700,
          textAlign: 'center',
          left: 0,
          position: 'absolute',
        },
      },
    },
    label: {
      fontWeight: 600,
      fontSize: 10,
      lineHeight: '12px',
      color: theme.oysterTheme.charcoal,
    },
    caption: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '22px',
      display: 'flex',
      alignItems: 'center',
      color: theme.oysterTheme.charcoal,
      marginBottom: 24,
      marginTop: 12,
    },
    value: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '17px',
      color: theme.oysterTheme.charcoal,
    },
    copyIcon: {
      '& svg path': {
        fill: ({ secondaryColor }: StyleProps) => secondaryColor,
      },
    },
  }),
);

export default useStyles;
